import PropTypes from 'prop-types';
import React from 'react';
import styles from './Button.module.scss';

const Button = ({ children, handleOnClick, isSmall, ...delegated }) => (
  <button {...delegated} className={`${styles.button} ${isSmall ? styles.small : ''}`} onClick={handleOnClick}>
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  handleOnClick: PropTypes.func.isRequired,
  isSmall: PropTypes.bool,
};

export default Button;
